const bodyHasClass = (className) => $('body').hasClass(className);

const isAccountPage = (accountPage) => bodyHasClass('page-template-page-account-' + accountPage);